// Awizacja import — data access for the matcher.
//
// Pulls the company + product reference sets the mapper matches against.
// Kept separate from the mapper so the matching logic stays pure/testable.

import { BaseDao, type SupabaseClient } from "../base.ts";

export interface CompanyRec {
  id: number;
  short_name: string | null;
  full_name: string | null;
  nip: string | null;
  city: string | null;
  zip_code: string | null;
  street: string | null;
  categories: string[] | null;
  parent_company_id: number | null;
}

export interface ProductRec {
  id: number;
  name: string | null;
  name_pl: string | null;
  waste_code: string | null;
  basel_code: string | null;
}

export class AwizacjaImportDao extends BaseDao<CompanyRec> {
  protected readonly dependentResources = ["companies", "products"];

  constructor(sb: SupabaseClient) {
    super(sb, "companies");
  }

  async loadCompanies(): Promise<CompanyRec[]> {
    const { data, error } = await this.sb
      .from("companies")
      .select("id, short_name, full_name, nip, city, zip_code, street, categories, parent_company_id")
      .eq("is_deleted", false);
    if (error) throw error;
    return (data ?? []) as CompanyRec[];
  }

  async loadProducts(): Promise<ProductRec[]> {
    const { data, error } = await this.sb
      .from("products")
      .select("id, name, name_pl, waste_code, basel_code")
      .eq("is_deleted", false);
    if (error) throw error;
    return (data ?? []) as ProductRec[];
  }
}
